import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/conciliacion';
import Conciliacion from './Conciliacion';


const ms2p = (state) => {
  return {
    ...state.conciliacion_bancaria,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Conciliacion);
